import { Skeleton } from '@/components/UI/Skeleton'
import { SPOT_OVERVIEW_CARD_CLASS, SPOT_OVERVIEW_THUMBNAIL_PX } from './SpotOverview'

/**
 * SpotOverview の形状に合わせたスケルトン。
 * スポット一覧（リスト表示）のローディング中に表示する。
 * カードのクラスとサムネイルの大きさは SpotOverview から共有し、ローディング解除時に行の高さが動かないようにする。
 */
export function SpotOverviewSkeleton() {
  return (
    <div className={SPOT_OVERVIEW_CARD_CLASS}>
      {/* サムネイル（rounded-16） */}
      <Skeleton
        variant="rect"
        width={SPOT_OVERVIEW_THUMBNAIL_PX}
        height={SPOT_OVERVIEW_THUMBNAIL_PX}
        className="shrink-0 rounded-[16px]"
      />

      {/* テキスト情報。縦間隔は SpotOverview と同じ gap-1（4px） */}
      <div className="flex min-w-0 flex-1 flex-col gap-1">
        {/* スポット名 1 行分（16px / line-height 24px） */}
        <Skeleton variant="text" width="70%" height={24} />
        {/* シート名バッジ 2 個分 */}
        <div className="flex gap-1">
          <Skeleton variant="rect" width={96} height={20} />
          <Skeleton variant="rect" width={72} height={20} />
        </div>
        {/* クーポン・タグバッジ行 */}
        <div className="flex gap-1">
          <Skeleton variant="rect" width={48} height={20} />
          <Skeleton variant="rect" width={56} height={20} />
        </div>
      </div>

      {/* 矢印 */}
      <Skeleton variant="circle" width={24} className="shrink-0 self-center" />
    </div>
  )
}
